import SideBar from '../sideBar/sideBar';

const Container = ({ children, header, selected }) => {
  return (
    <div className="flex">
      <div style={{ width: 300 }} className="bg-white min-h-screen">
        <SideBar selected={selected} />
      </div>
      <div className="px-5 py-4" style={{ width: '100%' }}>
        <div className="mb-6">{header}</div>
        <div className="overflow-x-hidden">{children}</div>
      </div>
    </div>
  );
};

export default Container;
